import axiosInstance from "./AxiosInstance";

const token = "e532c7ba3d7dd872df0f67576c161969";

export function getCategories(pagination , pageid ,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
  return axiosInstance.post("/admin/categoryList", {
    pagination,
    pageid,
    search_by, search_keyword, sort_by, sort_order
  });
}

export function updateCategory(categoryData, categoryId) {
  return axiosInstance.post(`/admin/editCategory`, {
    ...categoryData,
    category_id: categoryId,
  });
}

// Update the createCategory function
export function createCategory(categoryData) {
  return axiosInstance.post("/admin/addCategory", categoryData);
}

export function deleteCategory(category_id) {
  return axiosInstance.post("/admin/deleteCategory", category_id);
}

export function formatCategories(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((category) => ({
      ...category,
      category_id: category.category_id || category._id || category.id,
    }));
  }

  let categories = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      categories.push({
        ...responseData[key],
        category_id:
          responseData[key].category_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return categories;
}
